import { forwardRef } from "react";

import TriangleAlertIcon from "./itshover/triangle-alert-icon";
import ArrowBigLeftIcon from "./itshover/arrow-big-left-icon";
import ArrowBigRightIcon from "./itshover/arrow-big-right-icon";
import RosetteDiscountIcon from "./itshover/rosette-discount-icon";
import ChartBarIcon from "./itshover/chart-bar-icon";
import FilledBellIcon from "./itshover/filled-bell-icon";
import CodeXmlIcon from "./itshover/code-xml-icon";
import BookIcon from "./itshover/book-icon";
import LibraryIcon from "./itshover/library-icon";
import BrandGoogleIcon from "./itshover/brand-google-icon";
import BrandOpenaiIcon from "./itshover/brand-openai-icon";
import StackIcon from "./itshover/stack-icon";
import Stack3Icon from "./itshover/stack-3-icon";
import ClockIcon from "./itshover/clock-icon";
import CameraIcon from "./itshover/camera-icon";
import CheckedIcon from "./itshover/checked-icon";
import FilledCheckedIcon from "./itshover/filled-checked-icon";
import DoubleCheckIcon from "./itshover/double-check-icon";
import CodeIcon from "./itshover/code-icon";
import LocateIcon from "./itshover/locate-icon";
import CopyIcon from "./itshover/copy-icon";
import TrophyIcon from "./itshover/trophy-icon";
import PenIcon from "./itshover/pen-icon";
import EyeIcon from "./itshover/eye-icon";
import FileDescriptionIcon from "./itshover/file-description-icon";
import TargetIcon from "./itshover/target-icon";
import FlameIcon from "./itshover/flame-icon";
import KeyframesIcon from "./itshover/keyframes-icon";
import CurrencyEthereumIcon from "./itshover/currency-ethereum-icon";
import HandHeartIcon from "./itshover/hand-heart-icon";
import ChartCovariateIcon from "./itshover/chart-covariate-icon";
import GithubIcon from "./itshover/github-icon";
import HeartIcon from "./itshover/heart-icon";
import HomeIcon from "./itshover/home-icon";
import DialpadIcon from "./itshover/dialpad-icon";
import LayersIcon from "./itshover/layers-icon";
import LayoutDashboardIcon from "./itshover/layout-dashboard-icon";
import LinkedinIcon from "./itshover/linkedin-icon";
import UnorderedListIcon from "./itshover/unordered-list-icon";
import LockIcon from "./itshover/lock-icon";
import LogoutIcon from "./itshover/logout-icon";
import MailFilledIcon from "./itshover/mail-filled-icon";
import WorldIcon from "./itshover/world-icon";
import MapPinIcon from "./itshover/map-pin-icon";
import RosetteDiscountCheckIcon from "./itshover/rosette-discount-check-icon";
import DotsHorizontalIcon from "./itshover/dots-horizontal-icon";
import MessageCircleIcon from "./itshover/message-circle-icon";
import PaintIcon from "./itshover/paint-icon";
import PartyPopperIcon from "./itshover/party-popper-icon";
import PlayerIcon from "./itshover/player-icon";
import RefreshIcon from "./itshover/refresh-icon";
import RocketIcon from "./itshover/rocket-icon";
import MagnifierIcon from "./itshover/magnifier-icon";
import SendHorizontalIcon from "./itshover/send-horizontal-icon";
import GearIcon from "./itshover/gear-icon";
import ExternalLinkIcon from "./itshover/external-link-icon";
import ShieldCheck from "./itshover/shield-check";
import ShoppingCartIcon from "./itshover/shopping-cart-icon";
import TravelBag from "./itshover/travel-bag";
import MehIcon from "./itshover/meh-icon";
import SparklesIcon from "./itshover/sparkles-icon";
import StarIcon from "./itshover/star-icon";
import TerminalIcon from "./itshover/terminal-icon";
import TrashIcon from "./itshover/trash-icon";
import ChartLineIcon from "./itshover/chart-line-icon";
import TwitterIcon from "./itshover/twitter-icon";
import LetterAIcon from "./itshover/letter-a-icon";
import UserIcon from "./itshover/user-icon";
import UserPlusIcon from "./itshover/user-plus-icon";
import UsersIcon from "./itshover/users-icon";
import XIcon from "./itshover/x-icon";
import YoutubeIcon from "./itshover/youtube-icon";
import BatteryChargingIcon from "./itshover/battery-charging-icon";
import RainbowIcon from "./itshover/rainbow-icon";
import BulbSvg from "./itshover/bulb-svg";
import Cloud1Icon from "./itshover/cloud-1-icon";
import RadioIcon from "./itshover/radio-icon";
import Loader2Icon from "./itshover/loader-2-icon";

const adapt = (IconComponent, baseClassName = "") => {
  const WrappedIcon = forwardRef((props, ref) => {
    const { className = "", ...rest } = props || {};
    const mergedClassName = [baseClassName, className]
      .filter(Boolean)
      .join(" ");
    return <IconComponent ref={ref} className={mergedClassName} {...rest} />;
  });

  WrappedIcon.displayName = `Animated${IconComponent.displayName || "Icon"}`;
  return WrappedIcon;
};

export const AlertTriangle = adapt(TriangleAlertIcon);
export const ArrowLeft = adapt(ArrowBigLeftIcon);
export const ArrowRight = adapt(ArrowBigRightIcon);
export const Award = adapt(RosetteDiscountIcon);
export const BarChart = adapt(ChartBarIcon);
export const Bell = adapt(FilledBellIcon);
export const Binary = adapt(CodeXmlIcon);
export const Book = adapt(BookIcon);
export const BookOpen = adapt(LibraryIcon);
export const Bot = adapt(BrandOpenaiIcon);
export const Box = adapt(StackIcon);
export const BoxSelect = adapt(Stack3Icon);
export const Calendar = adapt(ClockIcon);
export const Camera = adapt(CameraIcon);
export const Check = adapt(CheckedIcon);
export const CheckCircle = adapt(FilledCheckedIcon);
export const CheckCircle2 = adapt(DoubleCheckIcon);
export const CheckCheck = adapt(DoubleCheckIcon);
export const Chrome = adapt(BrandGoogleIcon);
export const Code = adapt(CodeIcon);
export const Code2 = adapt(CodeXmlIcon);
export const Compass = adapt(LocateIcon);
export const Copy = adapt(CopyIcon);
export const Crown = adapt(TrophyIcon);
export const Edit = adapt(PenIcon);
export const Eye = adapt(EyeIcon);
export const FileText = adapt(FileDescriptionIcon);
export const Flag = adapt(TargetIcon);
export const Flame = adapt(FlameIcon);
export const FunctionSquare = adapt(KeyframesIcon);
export const Gem = adapt(CurrencyEthereumIcon);
export const Gift = adapt(HandHeartIcon);
export const GitGraph = adapt(ChartCovariateIcon);
export const Github = adapt(GithubIcon);
export const Heart = adapt(HeartIcon);
export const Home = adapt(HomeIcon);
export const Image = adapt(CameraIcon);
export const ImagePlus = adapt(CameraIcon);
export const Keyboard = adapt(DialpadIcon);
export const Layers = adapt(LayersIcon);
export const LayoutTemplate = adapt(LayoutDashboardIcon);
export const Linkedin = adapt(LinkedinIcon);
export const Library = adapt(LibraryIcon);
export const List = adapt(UnorderedListIcon);
export const Lock = adapt(LockIcon);
export const LogOut = adapt(LogoutIcon);
export const Mail = adapt(MailFilledIcon);
export const Map = adapt(WorldIcon);
export const MapPin = adapt(MapPinIcon);
export const Loader2 = adapt(Loader2Icon);
export const Medal = adapt(RosetteDiscountCheckIcon);
export const Menu = adapt(DotsHorizontalIcon);
export const MessageCircle = adapt(MessageCircleIcon);
export const MessageSquare = adapt(MessageCircleIcon);
export const MoreHorizontal = adapt(DotsHorizontalIcon);
export const Package = adapt(StackIcon);
export const Palette = adapt(PaintIcon);
export const PartyPopper = adapt(PartyPopperIcon);
export const Pencil = adapt(PenIcon);
export const Play = adapt(PlayerIcon);
export const Plus = adapt(XIcon, "rotate-45");
export const RefreshCw = adapt(RefreshIcon);
export const Repeat = adapt(RefreshIcon);
export const Rocket = adapt(RocketIcon);
export const Scroll = adapt(FileDescriptionIcon);
export const Search = adapt(MagnifierIcon);
export const Send = adapt(SendHorizontalIcon);
export const Settings = adapt(GearIcon);
export const Share2 = adapt(ExternalLinkIcon);
export const Shield = adapt(ShieldCheck);
export const ShoppingBag = adapt(TravelBag);
export const ShoppingCart = adapt(ShoppingCartIcon);
export const Smile = adapt(MehIcon);
export const Sparkles = adapt(SparklesIcon);
export const Star = adapt(StarIcon);
export const Target = adapt(TargetIcon);
export const Terminal = adapt(TerminalIcon);
export const Trash = adapt(TrashIcon);
export const Trash2 = adapt(TrashIcon);
export const TrendingUp = adapt(ChartLineIcon);
export const Trophy = adapt(TrophyIcon);
export const Twitter = adapt(TwitterIcon);
export const Type = adapt(LetterAIcon);
export const User = adapt(UserIcon);
export const UserPlus = adapt(UserPlusIcon);
export const Users = adapt(UsersIcon);
export const X = adapt(XIcon);
export const Youtube = adapt(YoutubeIcon);
export const Zap = adapt(BatteryChargingIcon);
export const Pin = adapt(MapPinIcon);
export const Activity = adapt(ChartLineIcon);
export const Clock = adapt(ClockIcon);
export const ExternalLink = adapt(ExternalLinkIcon);
export const ChevronRight = adapt(ArrowBigRightIcon);
export const Info = adapt(TriangleAlertIcon);
export const Cpu = adapt(BatteryChargingIcon);
export const Database = adapt(StackIcon);
export const HardDrive = adapt(LayersIcon);






// Extra aliases used by marketplace data and seeded backend icon_name values.
export const Rainbow = adapt(RainbowIcon);
export const Lightbulb = adapt(BulbSvg);
export const Snowflake = adapt(Cloud1Icon);
export const Circle = adapt(RadioIcon);
